var _path, _rect, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6657 11.9216V23.2539C30.6657 26.9391 27.6782 29.9266 23.9929 29.9266H15.5581C11.8728 29.9266 8.88533 26.9391 8.88533 23.2539V8.34716C8.88533 4.6619 11.8728 1.6744 15.5581 1.6744H20.4185V2.57972C20.4185 7.73909 24.601 11.9216 29.7603 11.9216H30.6657ZM28.6935 9.16766C25.8627 8.7128 23.6273 6.47733 23.1724 3.64656L28.6935 9.16766Z",
    fill: "#F7F5F2",
    stroke: "#BCC0CC",
    strokeWidth: 2.6691
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14.002,
    width: 21.573,
    height: 12.5843,
    rx: 4.67093,
    fill: "#E27366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57422 23.3502V17.3359H5.71799C6.1859 17.3359 6.57354 17.4211 6.88091 17.5914C7.18828 17.7618 7.41832 17.9947 7.57103 18.2904C7.72373 18.584 7.80009 18.9149 7.80009 19.2829C7.80009 19.653 7.72275 19.9858 7.56809 20.2814C7.41538 20.5751 7.18437 20.8081 6.87504 20.9803C6.56766 21.1507 6.181 21.2358 5.71505 21.2358H4.24084V20.4664H5.63282C5.92845 20.4664 6.16828 20.4155 6.35231 20.3137C6.53634 20.21 6.67143 20.069 6.75757 19.8908C6.84371 19.7127 6.88678 19.5101 6.88678 19.2829C6.88678 19.0558 6.84371 18.8542 6.75757 18.678C6.67143 18.5018 6.53536 18.3638 6.34937 18.2639C6.16534 18.1641 5.92258 18.1142 5.62108 18.1142H4.48165V23.3502H3.57422Z",
    fill: "#F7F5F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8109 23.3502H8.8639V17.3359H10.8726C11.4619 17.3359 11.968 17.4563 12.3908 17.6971C12.8137 17.936 13.1377 18.2796 13.3629 18.7279C13.59 19.1743 13.7035 19.7097 13.7035 20.3343C13.7035 20.9608 13.589 21.4992 13.3599 21.9494C13.1328 22.3997 12.8039 22.7463 12.3732 22.989C11.9425 23.2298 11.4217 23.3502 10.8109 23.3502ZM9.77133 22.5573H10.761C11.2191 22.5573 11.5999 22.4712 11.9033 22.2989C12.2068 22.1247 12.4339 21.8731 12.5847 21.5442C12.7354 21.2133 12.8108 20.81 12.8108 20.3343C12.8108 19.8625 12.7354 19.4621 12.5847 19.1332C12.4359 18.8043 12.2137 18.5547 11.918 18.3843C11.6224 18.214 11.2553 18.1288 10.8168 18.1288H9.77133V22.5573Z",
    fill: "#F7F5F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8319 23.3502V17.3359H18.5615V18.1171H15.7394V19.9496H18.2943V20.7278H15.7394V23.3502H14.8319Z",
    fill: "#F7F5F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.c51bf422fed36de0bfaf106448b05fbc.svg";
export { ForwardRef as ReactComponent };